/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowMurderMysteryPartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowMurderMysteryParty,

  planType: PlanType.Quickstart,
  suggestedTitles: ["Who Done It?", "A Night of Intrigue!", "Mystery Awaits!"],
  title: "Murder Mystery Party",
  description: "Organize a thrilling murder mystery party.",
  longDescription:
    "Gather your friends for an exciting murder mystery party! Choose a date, select a mystery theme, and plan the evening’s activities!",
  emoji: "🕵",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Murder Mystery Party",
          emoji: "🕵",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the murder mystery party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a mystery theme?",
            description: "What theme do we want for our murder mystery?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What mystery theme should we choose?",
                emoji: "🔍",
                completeAction: {
                  question: "Decide on roles for the evening?",
                  description: "What roles should we assign for the mystery?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What roles should we have?",
                      emoji: "🎭",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Time to Solve the Mystery!",
    outroDescription:
      "Your murder mystery party plans are set! Enjoy the intrigue!",
  },
};
